// import React, { useState } from "react";
import contact from "../assets/contact.png";
import email from "../assets/gmail.png";
import linkedin from "../assets/linkedin.png";
import ig from "../assets/instagram.png";
import fb from "../assets/facebook.png";  
import xlogo from "../assets/twitter.png";       
import { Link } from "react-router-dom";
// import emailjs from "emailjs-com";
const Contact = () => {
//     const [formData, setFormData] = useState({
//     name: "",
//     number: "",
//     email: "",
//     location: "",
//   });

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     // ---- 1️⃣ WhatsApp Message ----
//     const message = `
// New Enquiry Received:

// Name: ${formData.name}
// Phone: ${formData.number}
// Email: ${formData.email}
// Location: ${formData.location}
//     `;

//     const encoded = encodeURIComponent(message);
//     const myNumber = "91XXXXXXXXXX"; // ← Replace with your WhatsApp number

//     window.open(`https://wa.me/${myNumber}?text=${encoded}`, "_blank");

//     // ---- 2️⃣ Email Sending via EmailJS ----
//     emailjs
//       .send(
//         "service_vjys2hl",      // Replace
//         "YOUR_TEMPLATE_ID",     // Replace
//         formData,
//         "YOUR_PUBLIC_KEY"       // Replace
//       )
//       .then(() => {
//         alert("Form submitted successfully!");
//       })
//       .catch((error) => {
//         console.error("Email error:", error);
//       });
//   };
  return (
    <div className="py-5">
      <div className="py-5"></div>

      {/* TOP SECTION */}
      <section className="container text-center">
                    <h2 className="heading">
              Let's <span style={{ color: "#76ABAE" }}>Connect!</span>
            </h2>
                        <p className="content">
              Have questions about our financial solutions? Reach out to us—we’re here to help!
            </p>
      <div className="row">
        <div className="col-md-12">
            <div className="d-flex justify-content-center pt-5">
              <img
                src={contact}
                alt="Contact Us"
                className="img-fluid w-100"
                style={{ maxWidth: "600px" }}
              />
            </div>
        </div>
        {/* <div className="col-md-6">
            <div className="container">
              <form onSubmit={handleSubmit} className="shadow p-4 rounded-4">

        <input
          name="name"
          className="form-control bg-black rounded-pill my-5 py-2 text-white"
          placeholder="Enter your name"
          onChange={handleChange}
          required
        />

        <input
          name="number"
          className="form-control bg-black rounded-pill my-5 py-2 text-white"
          placeholder="Enter your phone number"
          onChange={handleChange}
          required
        />

        <input
          name="email"
          type="email"
          className="form-control bg-black rounded-pill my-5 py-2 text-white"
          placeholder="Enter your email"
          onChange={handleChange}
          required
        />

        <input
          name="location"
          className="form-control bg-black rounded-pill my-5 py-2 text-white"
          placeholder="Enter your location"
          onChange={handleChange}
          required
        />

        <button className="btn btn-light rounded-pill w-100 py-2" type="submit">
          Submit
        </button>

      </form>
            </div>
        </div> */}
      </div>
      </section>
      
      <div className="py-5"></div>

      {/* WAYS TO REACH US */}
      <section className="py-5">
        <div className="py-5"></div>

        <div className="container">
          <h2 className="heading text-center">
            Ways to <span style={{ color: "#76ABAE" }}>Reach</span> Us
          </h2>

          <div className="py-4"></div>

          {/* ROW 1 — 3 CARDS */}
          <div className="row justify-content-center">

            {/* EMAIL */}
            <div className="col-md-4 mb-4">
              <div
                className="p-4 rounded-4 shadow-lg text-white text-center"
                style={{
                  background: "rgba(255, 255, 255, 0.07)",
                }}
              >
                <div className="d-flex mb-3">
                  <div className="m-auto">
                    <img src={email} alt="" style={{ height: "50px", width: "50px" }} />
                  </div>
                </div>
                <h4>Email</h4>
                <p className="mb-0">aura.financials@gmail.com</p>
              </div>
            </div>

            {/* LINKEDIN */}
            <div className="col-md-4 mb-4">
              <div
                className="p-4 rounded-4 shadow-lg text-white text-center"
                style={{
                  background: "rgba(255, 255, 255, 0.07)",
                }}
              >
                <div className="d-flex mb-3">
                  <div className="m-auto">
                    <img src={linkedin} alt="" style={{ height: "50px", width: "50px" }} />
                  </div>
                </div>
                <h4>LinkedIn</h4>
                <Link
                  to="https://www.linkedin.com/in/aura-financials-1672911a2/"
                  className="text-decoration-none text-white"
                >
                  <p className="mb-0">@aura-financials</p>
                </Link>
              </div>
            </div>

            {/* INSTAGRAM */}
            <div className="col-md-4 mb-4">
              <div
                className="p-4 rounded-4 shadow-lg text-white text-center"
                style={{
                  background: "rgba(255, 255, 255, 0.07)",
                }}
              >
                <div className="d-flex mb-3">
                  <div className="m-auto">
                    <img src={ig} alt="" style={{ height: "50px", width: "50px"}} />
                  </div>
                </div>
                <h4>Instagram</h4>
                <Link
                  to="https://www.instagram.com/aura_financials/"
                  className="text-decoration-none text-white"
                >
                  <p className="mb-0">@aura_financials</p>
                </Link>
              </div>
            </div>
          </div>

          {/* ROW 2 — 2 CARDS CENTERED */}
          <div className="row justify-content-center">

            {/* FACEBOOK */}
            <div className="col-md-4 offset-md-1 mb-4">
              <div
                className="p-4 rounded-4 shadow-lg text-white text-center"
                style={{
                  background: "rgba(255, 255, 255, 0.07)",
                }}
              >
                <div className="d-flex mb-3">
                  <div className="m-auto">
                    <img src={fb} alt="" style={{ height: "50px", width: "50px" }} />
                  </div>
                </div>
                <h4>Facebook</h4>
                <Link
                  to="https://www.facebook.com/aura.financials.7"
                  className="text-decoration-none text-white"
                >
                  <p className="mb-0">@aura.financials</p>
                </Link>
              </div>
            </div>

            {/* X (TWITTER) */}
            <div className="col-md-4 mb-4">
              <div
                className="p-4 rounded-4 shadow-lg text-white text-center"
                style={{
                  background: "rgba(255, 255, 255, 0.07)",
                }}
              >
                <div className="d-flex mb-3">
                  <div className="m-auto">
                    <img src={xlogo} alt="" style={{ height: "50px", width: "50px" , borderRadius:"10px"}} />
                  </div>
                </div>
                <h4>X (Twitter)</h4>
                <Link
                  to="https://x.com/aura_financials"
                  className="text-decoration-none text-white"
                >
                  <p className="mb-0">@aura_financials</p>
                </Link>
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
